import Axios from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";

export function useRoadTypes() {
  async function queryFn(): Promise<string[]> {
    const response = await Axios.get(`/planning-api/roadtypes`);
    return response.data;
  }
  return useQuery<string[], Error>(baseDataKeys.roadTypes, () => queryFn(), {
    staleTime: 60 * 60 * 24 * 1000,
  });
}
